import { language as lan_functionBar } from "./function-bar";
import { language as lan_createFolderModal } from "./create-folder-modal";
import { language as lan_hintModal } from "./hint-modal";
import { language as lan_moveFileTreeModal } from "./move-file-tree-modal";
import { language as lan_previewModal } from "./preview-modal";
import { language as lan_renameFolderModal } from "./rename-folder-modal";
import { language as lan_setAsClientFilesModal } from "./set-as-client-files-modal";
import { language as lan_setAsShareFilesModal } from "./set-as-share-files-modal";
import { language as lan_uploadResultModal } from "./upload-result-modal";


let language = {
    ...lan_functionBar,
    ...lan_createFolderModal,
    ...lan_hintModal,
    ...lan_moveFileTreeModal,
    ...lan_previewModal,
    ...lan_renameFolderModal,
    ...lan_setAsClientFilesModal,
    ...lan_setAsShareFilesModal,
    ...lan_uploadResultModal,

    FILE_LIBRARY_TOTAL_FILES: "Total Files:",
    FILE_LIBRARY_TOTAL_FOLDERS: "Total Folders:",
    FILE_LIBRARY_TOTAL_SIZE: "Total Size:",

    FILE_LIBRARY_FILE_SELECTED: "Selected",

    // 
    FILE_LIBRARY_CREATE_FILE_LIBRARY_BTN: "Create file library",
    FILE_LIBRARY_SELECT_ALL_BTN: "Select All",
    FILE_LIBRARY_MOVE_TO_BTN: "Move to",
    FILE_LIBRARY_DELETE_BTN: "Delete",
    FILE_LIBRARY_PREVIEW_BTN: "Preview",
    FILE_LIBRARY_OPEN_BTN: "Open",
    FILE_LIBRARY_RENAME_BTN: "Rename",
    FILE_LIBRARY_LOAD_MORE_BTN: "Load more",
    FILE_LIBRARY_SET_AS_CLIENT_ROOT_FOLDER: "Set as client root folder",
    FILE_LIBRARY_SET_AS_SHARE_ROOT_FOLDER: "Set as share root folder",
    FILE_LIBRARY_CREATE_NEW_FOLDER: "Create new folder",

    // 
    FILE_LIBRARY_ELEMENT_TYPE: "Type:",
    FILE_LIBRARY_ELEMENT_TYPE_CATALOG: "Folder",
    FILE_LIBRARY_CLIENT_ROOT_FOLDER: "client root folder",
    FILE_LIBRARY_SHARE_ROOT_FOLDER: "share root folder",

    FILE_LIBRARY_ELEMENT_TOTAL_FOLDERS: "Total Folders:",
    FILE_LIBRARY_ELEMENT_TOTAL_FILES: "Total Files:",

    FILE_LIBRARY_ELEMENT_TYPE_IMAGE: "Image/",
    FILE_LIBRARY_IMAGE_SIZE: "Size:",
    FILE_LIBRARY_IMAGE_RESOLUTION: "Resolution:",
    FILE_LIBRARY_FILE_ID: "File ID:",

};

export { language }